import styled from 'styled-components';
import { TextParagraph, media, spacing, color } from '~/theme';
import colors from '~/theme/variables/colors';
import PasswordShow from '~/assets/icons/ontario-icon-password-show.svg';
import PasswordHide from '~/assets/icons/ontario-icon-password-hide.svg';
import PageAlert from '~/components/common/page-alerts';

export const StyledNumberShow = styled(PasswordShow)`
    margin-right: ${spacing.spacing2};
    path {
        fill: ${colors.darkBtnBG};
    }

    &:focus-visible {
        outline: 2px solid ${color.focusBlue};
        outline-offset: 2px;
    }
`;
export const StyledNumberHide = styled(PasswordHide)`
    margin-right: ${spacing.spacing2};
    path {
        fill: ${colors.darkBtnBG};
    }

    &:focus-visible {
        outline: 2px solid ${color.focusBlue};
        outline-offset: 2px;
    }
`;

export const StyledPageAlert = styled(PageAlert)`
    margin-bottom: ${spacing.spacing5};
`;

export const StyledTextParagraph = styled(TextParagraph)`
    margin-top: ${spacing.spacing5};
    @media ${media.small} {
        margin-top: ${spacing.spacing7};
    }
`;
export const StyledHRLine = styled.hr`
    height: 4px;
    border: none;
    background-color: ${colors.modalBorder};
`;
export const Container = styled.div`
    svg {
        flex-shrink: 0;
        margin-right: ${spacing.spacing1};
    }
`;

export default StyledNumberShow;
